import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu as MenuIcon, X, Coffee } from 'lucide-react';
const navLinks = [{
  name: 'Home',
  path: '/'
}, {
  name: 'About',
  path: '/about'
}, {
  name: 'Menu',
  path: '/menu'
}, {
  name: 'Contact',
  path: '/contact'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cafe-100/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-142">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-143">
        <NavLink to="/" className="flex items-center gap-2 group" data-id="element-144">
          <Coffee className="w-6 h-6 text-cafe-sage group-hover:text-cafe-800 transition-colors" data-id="element-145" />
          <span className="font-serif text-xl font-bold tracking-wide text-cafe-900" data-id="element-146">
            Brew & Bloom
          </span>
        </NavLink>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-147">
          {navLinks.map(link => <NavLink key={link.name} to={link.path} className={({
          isActive
        }) => `
                relative font-medium text-sm tracking-wider uppercase transition-colors
                ${isActive ? 'text-cafe-900' : 'text-cafe-800/70 hover:text-cafe-900'}
              `} data-id="element-148">
              {({
            isActive
          }) => <>
                  {link.name}
                  {isActive && <motion.div layoutId="navbar-indicator" className="absolute -bottom-1 left-0 right-0 h-[2px] bg-cafe-sage" initial={false} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 30
            }} data-id="element-149" />}
                </>}
            </NavLink>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-cafe-900 p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-150">
          {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-151" /> : <MenuIcon className="w-6 h-6" data-id="element-152" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-153">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-cafe-50 border-b border-cafe-800/10 overflow-hidden" data-id="element-154">
            <nav className="flex flex-col px-6 py-4 gap-4" data-id="element-155">
              {navLinks.map(link => <NavLink key={link.name} to={link.path} className={({
            isActive
          }) => `
                    font-serif text-lg py-2 border-b border-cafe-800/5
                    ${isActive ? 'text-cafe-sage font-bold' : 'text-cafe-800'}
                  `} data-id="element-156">
                  {link.name}
                </NavLink>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}